module.exports = __webpack_public_path__ + "static/media/undraw_knowledge_g5gf.9563fa33.svg";